import { render, staticRenderFns } from "./Bestaetigen.vue?vue&type=template&id=2376fcb3"
import script from "./Bestaetigen.vue?vue&type=script&lang=ts"
export * from "./Bestaetigen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports